import { Box, Drawer, Modal } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import React, { useMemo, useRef, useState } from "react";
import { AiFillCamera, AiOutlineBank } from "react-icons/ai";
import { BsFillPersonFill, BsPersonCircle } from "react-icons/bs";
import { FiEdit, FiLogOut } from "react-icons/fi";
import { LiaQuestionCircle } from "react-icons/lia";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import peopleImage from "../../assets/profile/people.svg";
import profileIcon from "../../assets/profile/profilePlaceHolder.svg";
import { ReactComponent as ShareIcon } from "../../assets/profile/shareIcon.svg";
import visImage from "../../assets/profile/visa.svg";
import Header from "../../common/Header";
import { getUserProfileDetails } from "../../redux/features/getUserProfile";
import { userLogOut } from "../../services/authServices";
import { updateProfilePhoto } from "../../services/services";
import BusinessPartner from "../businessPartner";
import EVisa_visaLancer from "./e_visaLancer/eVisa_visaLancer";
import HowItsWork_Carousel from "./howItsWork";
import style from "./profile.module.css";

import { Cropper } from "react-mobile-cropper";
import "react-mobile-cropper/dist/style.css";
import ImageCompressor from "image-compressor";
import LoadingSpinner from "../../common/Loader";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Profile = () => {
  const [isVisaLancer, setIsVisaLancer] = useState(false);
  const [isbusiness, setIsBusiness] = useState(false);
  const [isHowItsWork, setHowItsWork] = useState(false);
  const [userDetails, setUserDetails] = useState();
  const [profileSuccess, setProfileSuccess] = useState(false);
  const [srcFile, setSrcFile] = useState("");
  const [isUploadImage, setisUploadImage] = useState(false);

  const cropperRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user_id = localStorage.getItem("userId");
  // const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const session_id = localStorage.getItem("session_id");

  const userInfo = useSelector((state) => state.userProfile?.result?.data);

  useMemo(() => {
    setUserDetails(userInfo);
  }, [userInfo]);

  const callLogOutAPI = async () => {
    try {
      const request = await userLogOut(user_id, session_id);
      const response = await request.data;
      if (response.status == 1) {
        localStorage.clear();
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleImage = async (e) => {
    const updateImage = e.target.files[0];
    setSrcFile(URL.createObjectURL(updateImage));
    // callUpdateProfile(updateImage);
  };

  const callUpdateProfile = async (file) => {
    try {
      const user_id = localStorage.getItem("userId");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("profile_photo", file);

      const request = await updateProfilePhoto(formData);
      const response = await request.data;

      if (response.status == 1) {
        dispatch(getUserProfileDetails(user_id));
        setUserDetails({
          ...userDetails,
          profile_signed_url: response?.data?.profile_url,
        });
        setProfileSuccess(true);
        setisUploadImage(false);
        setSrcFile("");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const onCrop = async () => {
  //   const cropper = cropperRef.current;
  //   setisUploadImage(true);
  //   if (cropper) {
  //     const canvas = cropper.getCanvas();
  //     if (canvas) {
  //       let event = await fetch(canvas.toDataURL()).then((r) => r.blob());
  //       callUpdateProfile(event);
  //     }
  //   }
  // };

  const onCrop = async () => {
    const cropper = cropperRef.current;
    setisUploadImage(true);

    if (cropper) {
      const canvas = cropper.getCanvas();

      if (canvas) {
        // Convert the canvas to a data URL
        const dataURL = canvas.toDataURL("image/jpeg", 0.5); // Adjust the quality as needed
        const blob = await fetch(dataURL).then((res) => res.blob());

        // Call your updateProfile function with the compressed Blob
        callUpdateProfile(blob);
      }
    }
  };

  return (
    <>
      <Snackbar
        open={profileSuccess}
        autoHideDuration={3000}
        onClose={() => setProfileSuccess((prev) => !prev)}
      >
        <Alert
          onClose={() => setProfileSuccess((prev) => !prev)}
          // severity="n"
          sx={{ width: "100%", backgroundColor: "white" }}
        >
          <h4 style={{ color: "black", textAlign: "center" }}>
            Profile is successfully uploaded
          </h4>
        </Alert>
      </Snackbar>

      <Modal open={srcFile !== ""} onClose={() => setSrcFile("")}>
        <div
          style={{
            height: "100svh",
            background: "black",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {isUploadImage && <LoadingSpinner />}
          <Cropper
            ref={cropperRef}
            src={srcFile} //Upload File as URL
            style={{ width: "100%" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "2rem",
              padding: "2rem",
              flex: "1",
              width: "100%",
            }}
          >
            <button
              onClick={() => setSrcFile("")}
              style={{
                padding: "1rem",
                backgroundColor: "white",
                color: "black",
                letterSpacing: "normal",
                fontSize: "1rem",
                border: "none",
                width: "100%",
              }}
            >
              Cancel
            </button>
            <button
              onClick={onCrop}
              style={{
                padding: "1rem 2rem",
                backgroundColor: "var(--brandColor)",
                color: "white",
                fontSize: "1rem",
                border: "none",
                letterSpacing: "normal",
                width: "100%",
              }}
            >
              Done
            </button>
          </div>
        </div>
      </Modal>

      <Box>
        <Drawer
          anchor="bottom"
          PaperProps={{
            elevation: 0,
            style: { backgroundColor: "transparent", height: "100svh" },
          }}
          open={isVisaLancer}
          onClose={() => setIsVisaLancer(false)}
        >
          <EVisa_visaLancer close={setIsVisaLancer} />
        </Drawer>
        <Drawer
          anchor="bottom"
          PaperProps={{
            elevation: 0,
            style: { backgroundColor: "transparent", height: "100svh" },
          }}
          open={isbusiness}
          onClose={() => setIsBusiness(false)}
        >
          <BusinessPartner close={setIsBusiness} />
        </Drawer>

        {/* <Drawer
          anchor="bottom"
          PaperProps={{
            elevation: 0,
            style: { backgroundColor: "transparent", height: "100svh" },
          }}
          open={isHowItsWork}
        >
          <HowItsWork_Carousel close={setHowItsWork} />
        </Drawer> */}
        <Header navigateRoute={() => navigate("/")} header="Profile" />

        <Box sx={{ padding: "1rem" }}>
          <Box className={style.profile_userContainer}>
            <Box style={{ position: "relative" }}>
              <Box className={style.user_profile}>
                {userDetails?.profile_signed_url ? (
                  <img
                    src={userDetails?.profile_signed_url}
                    key={new Date().valueOf()}
                    style={{ objectFit: "cover", height: 80, width: 80 }}
                    onError={(e) => (e.target.src = profileIcon)}
                    loading="lazy"
                    alt="profile pic"
                  />
                ) : (
                  <BsFillPersonFill style={{ margin: 0, objectFit: "cover" }} />
                )}
              </Box>
              <Box className={style.update_photo}>
                <input
                  type="file"
                  onChange={handleImage}
                  style={{
                    backgroundColor: "black",
                    height: "100%",
                    width: "100%",
                    position: "absolute",
                    backgroundColor: "transparent",
                    paddingLeft: "50px",
                  }}
                />
                <AiFillCamera style={{ margin: 0 }} />
              </Box>
            </Box>

            <Box
              className={style.edit_profile}
              onClick={() => {
                navigate("/profile/edit-profile");
              }}
            >
              <FiEdit className={style.edit_icon} color="black" />
            </Box>
            <h4 className={style.userName}>
              {userDetails?.first_name} {userDetails?.last_name}
            </h4>
          </Box>
        </Box>
        <Box className={style.user_detailsContainer}>
          <Box
            className={style.user_details_box}
            onClick={() => {
              navigate("/profile/bank-details");
            }}
          >
            <AiOutlineBank
              className={style.user_details_boxIcon}
              style={{
                height: "1.5rem",
              }}
            />
            <h4>My bank details</h4>
          </Box>
          <Box
            className={style.user_details_box}
            onClick={() => {
              navigate("/customer-benefits");
            }}
          >
            <ShareIcon
              className={style.user_details_boxIcon}
              style={{
                height: "1.5rem",
              }}
            />
            <h4>Share customer benefits</h4>
          </Box>
          <Box
            className={style.user_details_box}
            onClick={() => setIsVisaLancer(true)}
          >
            <img src={visImage} className={style.user_details_boxIcon} />
            <h4>My VisaLancer benefits</h4>
          </Box>
          {/* <Box
            className={style.user_details_box}
            onClick={() => setHowItsWork(true)}
          >
            <LiaQuestionCircle
              className={style.user_details_boxIcon}
              style={{
                height: "2rem",
              }}
            />
            <h4>How it works</h4>
          </Box> */}
          <Box
            className={style.user_details_box}
            onClick={() => setIsBusiness(true)}
          >
            <img src={peopleImage} className={style.user_details_boxIcon} />
            <h4>Have a big client?</h4>
          </Box>
          <Box
            className={style.user_details_box}
            onClick={() => {
              callLogOutAPI();
            }}
          >
            <FiLogOut className={style.user_details_boxIcon} />
            <h4>Logout</h4>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Profile;
